<script lang="ts">
import {Options, Vue} from "vue-class-component";
import experienceStore from "@/store/modules/project/experienceStore";
import {openGraphMixin} from "@/assets/ogimage/openGraphMixin";

@Options({
  mixins: [openGraphMixin],
  data() {return {isCodersrankSummaryVisible: true,}},
  computed: {experienceStore() {return experienceStore}},
  mounted() {
    const mainTitle = 'My Experience';
    const title = 'Portfolio - My Experience';
    const metaDescription = 'Anatolii Zorin\'s Portfolio with all diplomas, certificates, interesting projects and a detailed description of the experience gained at previous jobs.';
    const description = 'Anatolii Zorin\'s Portfolio - My Experience';
    const imageUrl = 'https://zorin.expert/assets/ogimage/menu/OG_Image_Experience.jpg';
    const url = 'https://zorin.expert/experience';

    this.setOpenGraphTags(metaDescription, title, description, imageUrl, url);
    this.setPageTitle(mainTitle);
    this.setCanonical(url);
  },
  methods: {},
  components: {},
})
export default class Experience extends Vue {
};
</script>

<template>
  <div class="experience">
    <h1>
      {{ $t('experience.title') }}
    </h1>
    <line></line>
    <div class="container">
      <div class="work">
        <div v-for="exp in experienceStore.state.experienceStore" :key="exp.id">
          <h3>{{ exp.data_start }} -
            {{ this.$i18n.locale === "uk" ? exp.data_finish_ua : this.$i18n.locale === "es" ? exp.data_finish_es : exp.data_finish_en }}</h3>
          <h4><span style="color: black">{{
              $t('experience.company')
            }}: </span>{{ this.$i18n.locale === "uk" ? exp.company_ua : this.$i18n.locale === "es" ? exp.company_es : exp.company_en }}
          </h4>
          <h4><span style="color: black">{{
              $t('experience.job')
            }}: </span>{{ this.$i18n.locale === "uk" ? exp.job_ua : this.$i18n.locale === "es" ? exp.job_es : exp.job_en }}</h4>
          <p><span style="font-weight: bold; color: rebeccapurple">{{
              $t('experience.main-duties')
            }}: </span>{{
              this.$i18n.locale === "uk" ? exp.main_duties_ua : this.$i18n.locale === "es" ? exp.main_duties_es : exp.main_duties_en
            }}</p>
          <p><span style="font-weight: bold; color: rebeccapurple">{{
              $t('experience.related-duties')
            }}: </span>{{
              this.$i18n.locale === "uk" ? exp.related_duties_ua : this.$i18n.locale === "es" ? exp.related_duties_es : exp.related_duties_en
            }}</p>
          <p><span style="font-weight: bold; color: rebeccapurple">{{
              $t('experience.tasks')
            }}: </span>{{ this.$i18n.locale === "uk" ? exp.tasks_ua : this.$i18n.locale === "es" ? exp.tasks_es : exp.tasks_en }}</p>
          <p class="skills"><span style="color: black; font-style: normal; text-decoration: underline">{{
              $t('experience.skills')
            }}:</span> {{ exp.skills }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.experience {
  flex: 1 0 auto;
  text-align: left;
  background: linear-gradient(to bottom, rgb(229, 251, 255), rgb(255, 240, 244)) no-repeat center;

  .container {
    display: flex;
    flex-direction: column;

    .work {
      display: flex;
      flex-direction: column;
      font-size: 1.8rem;
      margin: 1rem 2rem;

      h3 {
        color: darkred;
        margin: 0.5rem auto;
        font-style: italic;
      }

      h4 {
        color: darkblue;
        margin: 0.5rem auto;
      }

      p {
        margin: 0.5rem auto;
        padding-left: 1rem;
      }

      .skills {
        font-size: 1.4rem;
        padding-left: 0;
        font-style: italic;
      }
    }
  }
}

@media(max-width: 1200px) {
  .experience {
    .container {
      .work {
        margin: 0.5rem 1rem;
        display: flex;
        flex-direction: column;
        font-size: 1.4rem;

        .skills {
          font-size: 1.1rem;
        }
      }
    }
  }
}

@media(max-width: 768px) {
  .experience {
    .container {
      .work {
        margin: 0 0.3rem;
        display: flex;
        flex-direction: column;
        font-size: 1rem;

        h3, h4, p {
          margin: 0.3rem;
        }

        .skills {
          font-size: 0.7rem;
        }
      }
    }
  }
}
</style>